// Inline phrase list editor — used by both the banned + signature lists in
// the voice editor (US-094, US-095). Wraps the DS `ChipInput` primitive so
// every editor surfaces the same add/remove/dedupe semantics.
//
// We don't compose a full `FieldAssembly` here because the parent
// (`VoiceEditorPage`) renders the field shell + label/hint copy via
// `FieldAssembly` and slots this control as the `children` element.

import { ChipInput } from '@barel/ui';

export interface PhraseListEditorProps {
  value: string[];
  onChange: (next: string[]) => void;
  placeholder: string;
  addCta: string;
  ariaLabel: string;
  removeAriaLabel: (tag: string) => string;
  /** `red` for banned, `green` for signature — mirrors the prototype glyph. */
  accent: 'banned' | 'signature';
  disabled?: boolean;
  testId?: string;
}

export function PhraseListEditor({
  value,
  onChange,
  placeholder,
  addCta,
  ariaLabel,
  removeAriaLabel,
  accent,
  disabled,
  testId,
}: PhraseListEditorProps) {
  const chipAccent = accent === 'banned' ? 'error' : 'accent';
  return (
    <div data-testid={testId}>
      <ChipInput
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        addButtonLabel={addCta}
        accent={chipAccent}
        aria-label={ariaLabel}
        removeAriaLabel={removeAriaLabel}
        disabled={disabled}
      />
    </div>
  );
}
